import React, { useEffect, useRef, useState } from "react";

export default function DocumentPreview({ url, document }) {
  const containerRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!url || !document) return;

    let active = true;

    const renderDocument = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(url);
        const blob = await response.blob();

        const { renderAsync } = await import("docx-preview");

        if (!active || !containerRef.current) return;

        containerRef.current.innerHTML = "";

        await renderAsync(
          blob,
          containerRef.current,
          undefined,
          {
            inWrapper: true,
            breakPages: true,
            useBase64URL: true,
          }
        );

        if (active) setLoading(false);
      } catch (err) {
        console.error("Error rendering DOCX:", err);

        if (active) {
          setError("Could not render this document.");
          setLoading(false);
        }
      }
    };

    renderDocument();

    return () => {
      active = false;

      if (containerRef.current) {
        containerRef.current.innerHTML = "";
      }
    };
  }, [url, document]);

  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      {loading && <span>Loading document...</span>}

      {error && (
        <span style={{ color: "var(--red-500)" }}>
          {error}
        </span>
      )}

      <div
        ref={containerRef}
        style={{
          display: loading ? "none" : "block",
          minHeight: "100%",
        }}
      />
    </div>
  );
}